<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="folder"/> Inleg
    </div>
    <div class="card-content" style="padding:0;">
      <div class="header-text">
        Jaar-/reserveringsruimte
      </div>
      <table class="new click-tr">
        <tr @click="spaceYear === new Date().getFullYear()
          ? spaceYear = new Date().getFullYear() -1
          : spaceYear = new Date().getFullYear()"
        >
          <td>
            <span :style="`color: ${spaceYear === new Date().getFullYear() -1 ? 'gray' : ''}`">
              {{ spaceYear }}
            </span>
          </td>
          <td><h2 :style="`color: ${spaceYear === new Date().getFullYear() -1 ? 'gray' : ''}`">
            &euro; {{
            formatPrice(
              Number(sumBy(
                filter(
                  $parent.mutations,
                  (o) => o.asset_name === 'Rekening courant'
                    && o.class === 'Storting'
                    && Number(o.total) > 0
                    && !o.storno
                    && (spaceYear === new Date().getFullYear()
                      ? (new Date(o.date).getFullYear()) === (new Date().getFullYear())
                      : (new Date(o.date).getFullYear()) === (new Date().getFullYear() -1)
                    )
                ),
                (o) => Number(o.total),
              ))
              , true
            )}}
          </h2></td>
        </tr>
      </table>
      <div class="header-text">
        Overdrachten
      </div>
      <table class="new click-tr">
        <tr @click="transferYear === new Date().getFullYear()
          ? transferYear = new Date().getFullYear() -1
          : transferYear = new Date().getFullYear()"
        >
          <td>
            <span :style="`color: ${transferYear === new Date().getFullYear() -1 ? 'gray': ''}`">
              {{ transferYear }}
            </span>
          </td>
          <td><h2 :style="`color: ${transferYear === new Date().getFullYear() -1 ? 'gray' : ''}`">
            &euro; {{
            formatPrice(
              Number(sumBy(
                filter(
                  $parent.mutations,
                  (o) => o.asset_name === 'Waarde overdracht'
                    && o.class === 'Storting'
                    && Number(o.total) > 0
                    && !o.storno
                    && (transferYear === new Date().getFullYear()
                      ? (new Date(o.date).getFullYear()) === (new Date().getFullYear())
                      : (new Date(o.date).getFullYear()) === (new Date().getFullYear() -1)
                    )
                ),
                (o) => Number(o.total),
              ))
              , true
            )}}
          </h2></td>
        </tr>
      </table>
      <p class="tip-text">
        Klik op een vak om te wisselen tussen vorig en dit jaar.
      </p>
      <p style="padding:10px;">
        Wilt u meer weten of denkt u dat het bedrag niet klopt?
        <a
          style="cursor:pointer; text-decoration: underline"
          @click="inlegInfo = true"
        >
          Klik hier
        </a>
        voor meer info en/of neem contact met ons op.
      </p>
      <div class="card-bottom">
        <a
          v-if="
            currentPort.iban || currentPort.brand === 'OXBY' || currentPort.brand === 'Doelbeleggen'
          "
          class="button secondary"
          style="float:left;"
          @click="openDeposit"
        >
          <awesomeIcon icon="wallet"/> Bijstorten
        </a>
        <a @click="uploadFile = true" class="button secondary">
          Kapitaal overdragen <awesomeIcon icon="file-download"/>
        </a>
      </div>
    </div>
    <modalWindow
      style="text-align:left;"
      v-show="inlegInfo" @close="inlegInfo = false" width="500"
    >
      <div class="titlebar">
        Inleg
      </div>
      <p style="padding:10px;">
        De totale inleg is de
        optelling van alle stortingen vanaf uw persoonlijke vaste tegenrekening
        {{currentPort.contra
          ? `(${currentPort.contra.replace(new RegExp('_', 'g'), '*')})`
          : ''
        }}. Dit totaal wordt gezien als
        <a
          target="_blank"
          href="https://www.belastingdienst.nl/wps/wcm/connect/nl/aftrek-en-kortingen/content/hoe-bereken-ik-mijn-jaarruimte"
        >
          jaar-/reserveringsruimte
        </a>
        en aan het eind van het jaar door ons opgegeven aan de belastingdienst. U kunt dit dan
        verrekenen met uw inkomstenbelasting.<br /><br />
        Geld dat afkomstig is van een andere rekening zoals van uw eenmanszaak, bedrijf of een
        <a
          target="_blank"
          href="https://www.doelbeleggen.nl/documentencentrum/protocol-stroomlijning-kapitaaloverdrachten/"
        >
          bank/verzekaar
        </a>, zien wij als overdracht en geven wij niet door aan de belastingdienst. Dit is eerder
        namelijk al opgegeven en kunt u niet nogmaals verrekenen met de belasting.
      </p>
    </modalWindow>
    <modalWindow v-if="uploadFile" @close="uploadFile = false" width="400">
      <div class="titlebar">
        Veilig bestanden uploaden
      </div>
      <div class="form-notice" v-if="tooltipText">
        {{tooltipText}}
      </div>
      <div class="inset">
        <p>
          Hieronder kunt u uw overdrachtsformulier veilig uploaden. Neem voor vragen over kapitaal
          overdracht contact met ons op via 'Contact opnemen' in het menu, wij helpen u graag
          verder.<br /><br />
           U kunt ons ook bellen op
          <a v-if="style=='ox'" href="tel://020-5550000" class="phonelink">020 - 555 0000</a>
          <a v-else-if="style=='vm'" href="tel://020-3449144" class="phonelink">020 - 344 9144</a>
          <a v-else-if="style=='bvs'" href="tel://020-5707808" class="phonelink">020 - 570 7808</a>
          <a v-else href="tel://020-5550055" class="phonelink">020 - 555 0055</a>.
        </p>
        <label for="pskuploadfile" class="file-label button psk-button">
          <awesomeIcon icon="upload"/> Kapitaal overdragen
        </label>
        <input
          style="display:none;" ref="files" id="pskuploadfile"
          type="file" name="img" @change="uploadFilesChanged"
        >
      </div>
    </modalWindow>
  </div>
</template>

<script>
import { filter, sumBy } from 'lodash-es';

export default {
  name: 'AnnualSpaceWidget',
  data() {
    return {
      spaceYear: new Date().getFullYear(),
      transferYear: new Date().getFullYear(),
      inlegInfo: false,
      style: process.env.VUE_APP_STYLE,
      tooltipText: '',
      uploadFile: false,
    };
  },
  computed: {
    currentPort() {
      return this.$parent.currentPort;
    },
  },
  created() {
    if (new Date().getMonth() <= 6) {
      this.spaceYear -= 1;
      this.transferYear -= 1;
    }
  },
  methods: {
    filter,
    sumBy,
    openDeposit() {
      this.$parent.deposit = !this.$parent.deposit;
    },
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFile(
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            // success
            this.tooltipText = 'We hebben uw overdrachtsformulier ontvangen.';
          } else {
            this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
          }
        },
        this.port,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  table.new {
    margin: 0 15px;
    width: calc(100% - 30px);
    h2 {
      margin: 0px;
    }
  }
  .header-text {
    text-align: left;
    text-transform: uppercase;
    font-size: 14px;
    color: $color-highlight;
    letter-spacing: 1px;
    margin: 10px 0 5px 15px;
  }
  .tip-text {
    width: calc(100% - 30px);
    text-align: left;
    font-size: 10px;
    color: gray;
    margin: 5px 0 0 15px;
  }
  .psk-button {
    display: block !important;
    height: initial !important;
    background-color: $color-highlight !important;
    float: none !important;
  }
</style>
